module.exports = __webpack_public_path__ + "static/img/v70ThreeDetailImg.3282b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70ThreeDetailImg.png
// module id = U/G/
// module chunks = 1